<template>
  <h6>
    <span class="custom-badge text-capitalize" :class="badgeClass">
      <i :class="badgeIcon" class="me-1" v-if="badgeIcon"></i>
      {{ status }}
    </span>
  </h6>
</template>

<script>
export default {
  name: "StatusBadge",
  props: {
    status: {
      type: String,
      default: ""
    }
  },
  computed: {
    badgeClass() {
      switch (this.status) {
        case "Terbit":
          return "badge-success";
        case "Perbaikan Persyaratan":
        case "Penolakan":
          return "badge-danger";
        case "Menunggu Verifikasi Dokumen":
        case "Dalam Proses":
          return "badge-warning";
        default:
          return "badge-secondary";
      }
    },
    badgeIcon() {
      switch (this.status) {
        case "Terbit":
          return "fa fa-check";
        case "Perbaikan Persyaratan":
        case "Penolakan":
          return "fa fa-times";
        case "Menunggu Verifikasi Dokumen":
        case "Dalam Proses":
          return "fa fa-clock-o";
        default:
          return "";
      }
    }
  }
};
</script>

<style scoped>
/* Base Style untuk Badge Kustom */
.custom-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.5rem 0.75rem; /* Setara px-3 py-2 */
  font-size: 0.875rem;
  font-weight: 500;
  border-radius: 50rem; /* Membuat bentuk pill (lonjong) */
  line-height: 1;
}

/* Warna untuk status: Disetujui */
.badge-success {
  background-color: #d1e7dd;
  color: #0f5132;
}

/* Warna untuk status: Ditolak */
.badge-danger {
  background-color: #f8d7da;
  color: #842029;
}

/* Warna untuk status: Verifikasi Teknis / Proses */
.badge-warning {
  background-color: #fff3cd;
  color: #664d03;
}

/* Warna untuk status Default / Lainnya */
.badge-secondary {
  background-color: #e2e3e5;
  color: #41464b;
}
</style>